import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { NotifyModalService } from '@pkg-services/notification/NotifyModal.service';
import { Notification, NotificationType } from '@pkg-services/notification/notification';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { IconsDirective } from '@pkg-directives/icons/icons.directive';

@Component({
  selector: 'notification',
  standalone: true,
  templateUrl: './notification.component.html',
  imports: [NgClass, IconsDirective],
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
  @Input() topBar: boolean = true;

  notifications: Notification[] = [];
  private _subscription: Subscription | undefined;

  constructor(private _notificationSvc: NotifyModalService) {}

  private _addNotification(notification: Notification) {
    this.notifications.push(notification);
    if (notification.timeout !== 0) {
      setTimeout(() => this.close(notification), notification.timeout);
    }
  }

  ngOnInit() {
    this._subscription = this._notificationSvc.getObservable().subscribe((notification) => this._addNotification(notification));
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  close(notification: Notification) {
    this.notifications = this.notifications.filter((notif) => notif.id !== notification.id);
  }

  className(notification: Notification): string {
    switch (notification.type) {
      case NotificationType.success:
        return 'success';
      case NotificationType.warning:
        return 'warning';
      case NotificationType.error:
        return 'error';
      default:
        return 'info';
    }
  }

  getNotificationIcon(notification: Notification): { icon: string; color: string } {
    switch (notification.type) {
      case NotificationType.success:
        return { icon: 'rocket', color: 'var(--main-green-color)' };
      case NotificationType.warning:
        return { icon: 'warning', color: '#ffc107' };
      case NotificationType.error:
        return { icon: 'moin-rounded', color: 'var(--main-orange-color)' };
      default:
        return { icon: 'infos-bubble', color: 'var(--main-blue-medium-color)' };
    }
  }

  getNotificationContainerClass(): string {
    return this.topBar ? 'notifications' : 'notifications no-topbar';
  }
}
